import request from "@/utils/request";

/**
 * 更新用户信息
 * @param data
 * @returns {*}
 */
export function updateusers(data) {
  return request({
    url: "/pc/user",
    method: "put",
    data: data,
  });
}

/**
 * 退出登录
 */
export function logout() {
  return request({
    url: "/pc/user/logout",
    method: "get",
  });
}

/**
 * 获取子用户列表
 */
export function getUserChildren(data) {
  return request({
    url: "/pc/user/children",
    method: "get",
    params: data,
  });
}

/**
 * 获取用户信息
 */
export function getPermission() {
  return request({
    url: "/api/membership/permission-list",
    method: "get",
  });
}
/**
 * 获取用户配置
 */
export function getSetting() {
  return request({
    url: "/pc/subject/exam/get-setting",
    method: "get",
  });
}
/**
 * 保存用户配置
 */
export function saveSetting(data) {
  return request({
    url: "/pc/subject/exam/save-setting",
    method: "post",
    data,
  });
}

/**
 * 创建子用户列表
 */
export function createChildren(data) {
  return request({
    url: "/pc/user/create-child",
    method: "post",
    data: data,
  });
}

/**
 * 删除子用户列表
 */
export function destroyChildren(id) {
  return request({
    url: `/pc/user/${id}/destroy-child`,
    method: "delete",
  });
}

/**
 * 切换用户
 */
export function swichUser(id) {
  return request({
    url: `/pc/user/switch-user`,
    method: "post",
    data: { id },
  });
}
/**
 * 切换用户
 */
export function getUserInfo() {
  return request({
    url: `/pc/user/info`,
    method: "get",
  });
}
